/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userAmazonCatalogue.internal

import kangaroorewards.appsdk.core.network.base.Endpoint

/**
 * The HTTP endpoint for the [UserAmazonCatalogueApi].
 *
 * [Endpoint] has a single [Endpoint.path] parameter ex. "users/me"
 */
internal val UserAmazonCatalogueEndpoint = Endpoint(path = "users/me/rewards?page={pageNumber}&per_page={perPage}&include=external_products&keywords={keywords}&searchRefinements={filters}")
